// extracted by mini-css-extract-plugin
module.exports = {"evidence-wrapper":"EvidenceContainer_evidence-wrapper__20e1b"};